import React from 'react';
import { getScoreColor } from '../../utils/styleUtils';
import { formatTaskName } from '../../utils/formatUtils';
import { getScoreKey } from '../../utils/dataUtils';
import { getCategory } from '../../utils/categoryUtils';

/**
 * Row renderer component for virtualized list in mobile view
 * 
 * @param {Object} props - Component props
 * @param {Object} props.item - Data item for this row
 * @param {Object} props.style - Style object from react-window
 * @param {number} props.index - Row index
 * @param {Function} props.openModal - Function to open the model scores modal
 * @param {Array} props.modelColumns - Array of model objects
 * @param {Array} props.visibleModels - Array of currently visible models
 * @param {boolean} props.isMobileView - Whether mobile view is active
 */
const RowRenderer = ({
  item,
  style,
  index,
  openModal,
  modelColumns,
  visibleModels,
  isMobileView
}) => {
  // Helper function to determine if a model is one of the company's ASI models
  const isCompanyModel = (modelId) => {
    return modelId === 'asi1_mini' || modelId === 'asi1_mini_0225';
  };
  return (
    <div 
      style={style} 
      className={`border-b ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 cursor-pointer transition-colors`}
      onClick={() => {
        console.log('Row clicked:', item.id, item.task);
        openModal(item);
      }}
    >
      <div className="flex items-center p-2">
        <div className="w-8 text-xs text-center">{item.id}</div>
        <div className="flex-1 px-2 text-xs font-medium" title={item.task}>
          {formatTaskName(item.task)}
        </div>
        {isMobileView ? (
          <div className={`w-12 text-center text-xs p-1 rounded ${getScoreColor(item.scores[getScoreKey(visibleModels[0].id)])}`}>
            {item.scores[getScoreKey(visibleModels[0].id)]}
          </div>
        ) : (
          visibleModels.map((model) => {
            const scoreKey = getScoreKey(model.id);
            return (
              <div 
                key={`${item.id}-${model.id}`} 
                className={`w-12 text-center text-xs ${getScoreColor(item.scores[scoreKey])}`}
              >
                {item.scores[scoreKey]}
              </div>
            );
          })
        )}
        {isMobileView && (
          <div className="w-6 text-center">
            <span className="inline-block w-5 h-5 rounded-full border border-blue-300 bg-blue-50 text-blue-600 text-xs font-semibold leading-5">i</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RowRenderer;
